import { Percent } from '@cowprotocol/currency'

export const LIMIT_ORDER_SLIPPAGE = new Percent(0)
export const LOW_RATE_THRESHOLD_PERCENT = -5
